import { createFileRoute } from '@tanstack/react-router'
import { Outlet } from '@/libs/router'
import { SettingsNav } from '@/features/settings/ui/settings-nav'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/settings')({
	component: SettingsLayout,
})

function SettingsLayout() {
	return (
		<PageLayout className='max-w-200'>
			<SettingsNav />
			<Outlet />
		</PageLayout>
	)
}
